import { render, staticRenderFns } from "./StatusAutoComplete.vue?vue&type=template&id=36c81f5a&scoped=true&"
import script from "./StatusAutoComplete.vue?vue&type=script&lang=js&"
export * from "./StatusAutoComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c81f5a",
  null
  
)

export default component.exports